var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"remote_monitor_spinner_container"},[_c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"loader dots-wave"},[_c('span',{staticClass:"dot"}),_c('span',{staticClass:"dot"}),_c('span',{staticClass:"dot"})])])])
}]

export { render, staticRenderFns }